// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1131":"f4fd8ab8","2446":"71baf423"}[chunkId] + ".chunk.css";
};